import { useState } from "react";
import axios from "axios";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await axios.post(
        "https://api.istpoverseas.com/api/admin/auth/login",
        { email, password }
      );

      localStorage.setItem("admin_token", res.data.token);
      window.location.href = "/admin";
    } catch (err) {
      setError(err.response?.data?.message || "Invalid credentials. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <form onSubmit={login} style={styles.form}>
        <h2 style={styles.title}>Admin Portal</h2>
        <p style={styles.subtitle}>Sign in to manage your dashboard</p>

        {error && <div style={styles.error}>{error}</div>}

        <div style={styles.inputGroup}>
          <label style={styles.label}>Email Address</label>
          <input
            type="email"
            placeholder="admin@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
            required
          />
        </div>

        <div style={styles.inputGroup}>
          <label style={styles.label}>Password</label>
          <input
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            required
          />
        </div>

        <button 
          type="submit" 
          style={{ ...styles.button, opacity: loading ? 0.7 : 1 }}
          disabled={loading}
        >
          {loading ? "Signing in..." : "Login"}
        </button>
      </form>
    </div>
  );
}

// Modern, clean inline styles
const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#f4f6f9",
    fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },
  form: {
    backgroundColor: "#ffffff",
    padding: "2.5rem",
    borderRadius: "12px",
    boxShadow: "0 8px 24px rgba(149, 157, 165, 0.2)",
    width: "100%",
    maxWidth: "400px",
    boxSizing: "border-box",
  },
  title: {
    margin: "0 0 0.5rem 0",
    color: "#1a202c",
    fontSize: "1.75rem",
    fontWeight: "600",
    textAlign: "center",
  },
  subtitle: {
    margin: "0 0 2rem 0",
    color: "#718096",
    fontSize: "0.95rem",
    textAlign: "center",
  },
  inputGroup: {
    marginBottom: "1.25rem",
  },
  label: {
    display: "block",
    marginBottom: "0.5rem",
    color: "#4a5568",
    fontSize: "0.875rem",
    fontWeight: "500",
  },
  input: {
    width: "100%",
    padding: "0.75rem 1rem",
    borderRadius: "6px",
    border: "1px solid #cbd5e0",
    fontSize: "1rem",
    boxSizing: "border-box",
    transition: "border-color 0.2s",
    outline: "none",
  },
  button: {
    width: "100%",
    padding: "0.75rem",
    backgroundColor: "#d41212",
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    fontSize: "1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background-color 0.2s",
    marginTop: "0.5rem",
  },
  error: {
    backgroundColor: "#fed7d7",
    color: "#c53030",
    padding: "0.75rem",
    borderRadius: "6px",
    fontSize: "0.875rem",
    marginBottom: "1.25rem",
    textAlign: "center",
    border: "1px solid #feb2b2",
  },
};